<template>
  <!-- 商品选择器 -->
  <el-dialog
    :visible.sync="dialogVisible"
    title="服务产品选择器"
    center
    width="1456px"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @open="openDialog"
  >
    <!-- <template slot="header"> -->
    <el-input
      @keyup.enter.native="getSearch"
      style="width: 200px;margin-right: 20px;"
      class="filter-item"
      placeholder="请输入产品标题"
      size="small"
      v-model="listQuery.keyword"
    ></el-input>
    <el-button @click="getSearch" class="filter-item" type="primary" icon="search" size="small">搜索</el-button>
    <el-button @click="getReset" class="filter-item" icon="search" size="small">重置</el-button>
    <!-- </template> -->
    <el-table
      size="small"
      :data="list"
      ref="comRef"
      stripe
      border
      highlight-current-row
      style="margin-top: 20px"
      :row-key="getRowKeys"
      @select="selectHandle"
      @select-all="selectAllHandle"
    >
      <el-table-column align="center" label width="180" type="selection"></el-table-column>
      <el-table-column align="center" label="id">
        <template slot-scope="scope">
          <span>{{ scope.row.id }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="名称">
        <template slot-scope="scope">
          <span>{{ scope.row.name }}</span>
        </template>
      </el-table-column>

      <el-table-column align="center" label="标题">
        <template slot-scope="scope">
          <span>{{ scope.row.title }}</span>
        </template>
      </el-table-column>
      <el-table-column label="图标" align="center">
        <template slot-scope="scope">
          <img :src="scope.row.icon" style="width: 80px; height: 80px; object-fit: cover" />
        </template>
      </el-table-column>
      <el-table-column align="center" label="完成天数">
        <template slot-scope="scope">
          <span>{{ scope.row.completionDays }}</span>
        </template>
      </el-table-column>

      <el-table-column align="center" label="价格">
        <template slot-scope="scope">
          <span>{{ scope.row.price }}</span>
        </template>
      </el-table-column>
      <el-table-column label="状态" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.status === 0">下架</span>
          <span v-if="scope.row.status === 1">上架</span>
        </template>
      </el-table-column>

      <el-table-column align="center" label="推介指数">
        <template slot-scope="scope">
          <el-rate
              v-model="scope.row.starLevel"
              disabled
          >
          </el-rate>
        </template>
      </el-table-column>
    </el-table>
    <!-- 页码 -->
    <template slot="footer">
      <div style="display:flex;justify-content:space-between;align-items:center;">
        <div style="display: flex;width:200px;font-size:14px;align-items:center;">
          最多可选
          <div style="color:red;margin:0 15px">{{ limit ? limit + '个商品' : '无限制' }}</div>已选：
          <div style="color:red;margin-top:2px">{{multipleSelection.length}}</div>
        </div>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="listQuery.currentPage"
          :page-sizes="[10,20,30, 50]"
          :page-size="listQuery.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          style="width:500px"
        ></el-pagination>
        <div style="width:155px">
          <el-button @click="getRem()">取 消</el-button>
          <el-button @click="getData()" type="primary">确定</el-button>
        </div>
      </div>
    </template>
  </el-dialog>
</template>

<script>
import { getSpuList } from '@/api/demo/commodity/index'
import { getProductList } from '@/api/merchant/service/product'
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    selectList: {
      type: Array,
      default () {
        return []
      }
    },
    limit: {
      // 最大限制选择数量
      type: [Number, String],
      default: 0
    },
    top: {
      type: String,
      default: '3vh'
    },
    width: {
      type: String,
      default: '66%'
    },
    center: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      list: [], // 商品列表
      total: 0, // 商品
      isFilter: false,
      listLoading: true, // 加载圈圈
      listQuery: {
        currentPage: 1,
        pageSize: 20,
        keyword: ''
      },
      multipleSelection: [], // 指定商品

      selectSpuIds: [] // 选中的spuIds,回显数据匹配
    }
  },
  computed: {
    dialogVisible: {
      get () {
        return this.visible
      },
      set (val) {
        this.$emit('update:visible', val)
      }
    },
    comSelectList: {
      // 回传给调用组件者
      get () {
        return this.selectList
      },
      set (list) {
        this.$emit('update:selectList', list)
      }
    }
  },
  watch: {
    visible (newValue) {
      if (newValue === true) {
        this.getList()
      }
    }
  },
  methods: {
    // 查询列表
    getList () {
      let that = this
      that.listLoading = true
      getProductList(that.listQuery).then(res => {
        that.list = res.records
        this.$nextTick(() => {
          this.$refs.comRef.clearSelection()
          res.records.forEach(item => {
            if (this.selectSpuIds.includes(item.id)) {
              this.$refs.comRef.toggleRowSelection(item, true)
            }
          })
        })
        that.total = parseInt(res.total)
        that.listLoading = false
      })
    },
    // Dialog打开的回调
    openDialog () {
      this.multipleSelection = this.selectList
      if (this.multipleSelection.length > 0) {
        this.selectSpuIds = this.multipleSelection.map(item => item.id)
        // console.log('this.multipleSelection',this.multipleSelection)
      }
    },
    // 行数据的 Key，用来优化 Table 的渲染
    getRowKeys (row) {
      return row.id
    },
    // 每页条数
    handleSizeChange (val) {
      this.listQuery.pageSize = val
      this.getList()
    },
    // 当前页
    handleCurrentChange (val) {
      this.listQuery.currentPage = val
      if (this.multipleSelection.length > 0) {
        this.selectSpuIds = this.multipleSelection.map(item => item.id)
      }
      this.getList()
    },
    // 搜索
    getSearch () {
      this.getList()
      this.listQuery.currentPage = 1
      this.isFilter = true
    },
    // 重置
    getReset () {
      this.listQuery.keyword = ''
      this.listQuery.currentPage = 1
      this.getList()
      this.isFilter = false
    },
    selectHandle (selection) {
      this.multipleSelection = selection
      if (this.limit == 6 && selection.length > 6) {
        let delRow = selection.shift()
        this.$refs.comRef.toggleRowSelection(delRow, false)
        this.multipleSelection = selection
      }
    },
    selectAllHandle (selection) {
      this.multipleSelection = selection
    },
    // 确定
    getData () {
      this.comSelectList = this.multipleSelection
      this.dialogVisible = false
      this.listQuery.currentPage = 1
      this.selectSpuIds = []
      console.log('on-select', this.multipleSelection)
      this.$emit('on-select', this.multipleSelection)
      //   console.log('this.tempSelectList',this.multipleSelection,this.comSelectList)
      this.multipleSelection = []
    },
    getRem () {
      this.dialogVisible = false
      this.listQuery.currentPage = 1
      this.selectSpuIds = []
      this.multipleSelection = []
      this.$refs.comRef.clearSelection()
    },
    closedFn () {
      //   this.$refs.newFormRef.clearValidate();
    }
  }
}
</script>
